import { useMemo } from "react";

import { MasqueradeEntityIcon } from "@/react/components/MasqueradeBanner/MasqueradeEntityIcon";
import type { MasqueradingEntity } from "@/react/types/Masquerading";

export const entityKey = (entity: MasqueradingEntity) =>
  `${entity.type}:${entity.id}`;

export const withCurrentEntity = (
  records: MasqueradingEntity[],
  currentEntity?: MasqueradingEntity,
) =>
  currentEntity
    ? [
        currentEntity,
        ...records.filter(
          entity => entityKey(entity) !== entityKey(currentEntity),
        ),
      ]
    : records;

export const entityOption = (entity: MasqueradingEntity) => ({
  value: entityKey(entity),
  label: entity.name,
  prefix: <MasqueradeEntityIcon entity={entity} />,
});

export const useSelectedEntityOption = (entity?: MasqueradingEntity) => {
  const { id, name, type } = entity ?? {};
  return useMemo(
    () =>
      id === undefined || !type
        ? null
        : { value: `${type}:${id}`, label: name ?? "" },
    [id, name, type],
  );
};
